import React, { useState } from 'react';
import {
  StyleSheet, Text, TouchableOpacity, View,
} from 'react-native';
import { DraggableGrid } from 'react-native-draggable-grid';
import {
  All_screens, cancel_str, getSubCategoryId, Save_new_order,
} from '../utils/DictionaryManagementUtils';
import { arrangeScreenInJson } from '../screens/ScreensOrdering';
import FullPagePanel from '../components/PanelsComponents/General/FullPagePanel';
import { LocStr } from '../utils/Utils';
import SortCard from '../components/PanelsComponents/SortOrder/SortCard';

//= ========================================================================
const Panel_B13_FlowChangeOrder = ({
  globJSON,
  selectedScreen,
  onConfigChanged,
  language,
}) => {
  const myScreen = globJSON.screens[selectedScreen];
  const subCategoryId = getSubCategoryId(myScreen);
  const service = globJSON.configurations.services[subCategoryId];

  const [steps, setSteps] = useState(service.screens_ordering.map((step) => ({ key: step })));

  const onSaveOrder = () => {
    service.screens_ordering = steps.map((item) => item.key);
    arrangeScreenInJson(globJSON, onConfigChanged);
  };

  const onDragRelease = (dataList) => {
    setSteps(dataList);
  };
  const render_item = (item) => (
    <View style={{ height: 54, width: 524 }} key={item.key}>
      <SortCard
        step={item.key}
        globJSON={globJSON}
        language={language}
      />
    </View>
  );

  return (
    <FullPagePanel
      globJSON={globJSON}
      onConfigChanged={onConfigChanged}
      selectedScreen={selectedScreen}
      onStepPressed={() => {
      }}
      panelHeadline={`${LocStr(All_screens, language)} ${service.name}`}
      tooltipsTitles={service.screens_ordering}
      language={language}
    >
      <View
        style={{
          width: 524,
          height: 500,
          marginLeft: 18,
          marginTop: 15,
        }}
      >
        <DraggableGrid
          numColumns={1}
          renderItem={render_item}
          itemHeight={54}
          data={steps}
          onDragStart={() => {
            // collapseAllFields();
          }}
          onDragRelease={onDragRelease}
        />
      </View>
      <View style={styles.controlPanelBottomBar}>
        <TouchableOpacity
          style={styles.btnBack}
          onPress={() => {
            onConfigChanged(false);
          }}
        >
          <Text style={styles.bottomLabel}>{LocStr(cancel_str, language)}</Text>
        </TouchableOpacity>
        <TouchableOpacity
          style={styles.btnSend}
          onPress={() => {
            onSaveOrder();
          }}
        >
          <Text style={styles.bottomLabelWhite}>
            {LocStr(Save_new_order, language)}
          </Text>
        </TouchableOpacity>
      </View>

    </FullPagePanel>
  );
};

const styles = StyleSheet.create({
  controlPanelBottomBar: {
    height: 73,
    flexDirection: 'row',
    backgroundColor: '#f0f5f9',
  },
  btnBack: {
    height: 71,
    flex: 1,
    marginTop: 2,
    justifyContent: 'center',
    backgroundColor: '#fff',
  },
  btnSend: {
    height: 71,
    flex: 1,
    marginTop: 2,
    marginLeft: 2,
    justifyContent: 'center',
    backgroundColor: '#008cff',
  },
  bottomLabel: {
    // height: 70,
    fontFamily: 'Rubik-Medium',
    fontSize: 18,
    color: '#001a2f',
    position: 'absolute',
    // marginTop: 52,
    alignSelf: 'center',
    // backgroundColor: '#f00',
  },
  bottomLabelWhite: {
    // height: 70,
    fontFamily: 'Rubik-Medium',
    fontSize: 18,
    color: '#fff',
    position: 'absolute',
    // marginTop: 52,
    alignSelf: 'center',
    // backgroundColor: '#f00',
  },

  lblTopGrey: {
    fontFamily: 'Rubik-Regular',
    fontSize: 14,
    marginTop: 3,
    color: '#718096',
  },
  imgBreadcrumbs: {
    width: 24,
    height: 24,
  },
  lblMainTitle: {
    width: 460,
    fontFamily: 'Quicksand-SemiBold',
    fontSize: 24,
    color: '#001a2f',
    // position: 'absolute',
  },
  lblMainBody: {
    width: 460,
    fontFamily: 'Rubik-Regular',
    fontSize: 16,
    color: '#4a5568',
    // position: 'absolute',
  },
  lblMainBody1: {
    width: 460,
    fontFamily: 'Rubik-Regular',
    fontSize: 16,
    color: '#001a2f',
    // position: 'absolute',
  },
  lblMainBodyBlue: {
    width: 460,
    fontFamily: 'Rubik-Regular',
    fontSize: 16,
    color: '#008cff',
  },
  lblGreenTitle: {
    width: 412,
    fontFamily: 'Quicksand-Bold',
    fontSize: 16,
    color: '#001a2f',
  },
  lblGreenBody: {
    width: 412,
    fontFamily: 'Quicksand-Medium',
    fontSize: 16,
    color: '#001a2f',
  },
  lblTitle20: {
    width: 412,
    fontFamily: 'Quicksand-Bold',
    fontSize: 20,
    color: '#001a2f',
  },
  lblBtnText: {
    width: 71,
    fontFamily: 'Rubik-Regular',
    fontSize: 14,
    color: '#001a2f',
    textAlign: 'center',
  },
  lblTitle16: {
    width: 460,
    fontFamily: 'Rubik-Regular',
    fontSize: 16,
    color: '#001a2f',
  },
});

export default Panel_B13_FlowChangeOrder;
